// extracted by extract-css-chunks-webpack-plugin
module.exports = {"lifeLinkPaymentPayoutOverview":"_3wU081","tables":"UiBBYN","spinnerHolder":"_2oKE6l","errMsg":"_5kmvVV","modal":"_3VSwxU","open":"AtMpPH"};